// English is a deferred locale. Keys left empty fall back to Dutch (fallbackLocale).
// Translate here when English is prioritised.
export default {
  table: {
    search: "Search",
    filter: "Filter",
    from: "From",
    to: "To",
    clear: "Clear filters",
    density: "Show more compact",
    empty: "No results.",
    empty_filtered: "No results for these filters.",
    range: "{from}–{to} of {total}",
    prev: "Previous",
    next: "Next",
  },
  facturen: {
    empty: "No invoices from Pandig yet.",
    billing: {
      eyebrow: "Payment to Pandig",
      price: "{fee} per active unit + {vat}% VAT",
      monthly: "{count} active units · {total} per month",
      error: "We couldn't start the payment mandate. Please try again.",
      state: {
        none: {
          title: "Activate billing",
          body: "Authorise once through iDEAL. Pandig will then charge automatically each month for your active units and issue a VAT invoice.",
          cta: "Authorise with iDEAL",
        },
        pending: {
          label: "Processing",
          title: "Mandate is being processed",
          body: "Mollie is processing your authorisation. Refresh shortly, or restart iDEAL if you did not complete the payment.",
          cta: "Restart iDEAL",
        },
        active: {
          label: "Active",
          title: "Billing is active",
          body: "The monthly charge automatically follows the number of active units. Each debit produces a VAT invoice here.",
        },
        ready: {
          label: "Mandate active",
          title: "Ready for active units",
          body: "Your mandate is valid. Pandig will automatically start monthly billing when you activate a unit.",
        },
        attention: {
          label: "Action needed",
          title: "Synchronise billing",
          body: "Your mandate is valid, but the monthly subscription is not active yet. Try synchronising it again.",
          cta: "Synchronise again",
        },
        retry: {
          label: "Renew",
          title: "Renew your mandate",
          body: "The previous mandate is no longer valid. Authorise again through iDEAL to resume billing.",
          cta: "Authorise again",
        },
      },
    },
    col: {
      number: "Invoice",
      period: "Period",
      units: "Units",
      per_unit: "Per unit",
      subtotal: "Subtotal",
      vat: "VAT",
      total: "Total",
      status: "Status",
    },
  },
  dashboard: {
    refresh: "Refresh",
  },
};
